export default __webpack_public_path__ + "static/media/上.ccbaf5fd.png";